export var BindAccountType;
(function (BindAccountType) {
    BindAccountType["DEBIT_CARD"] = "debit_card";
    BindAccountType["CRYPTO_TRC"] = "trc20";
    BindAccountType["CRYPTO_ERC"] = "erc20";
    BindAccountType["TOPAY"] = "topay";
    BindAccountType["EBPAY"] = "ebpay";
    BindAccountType["GOUBAO"] = "goubao";
    BindAccountType["CGPAY"] = "cgpay";
    BindAccountType["KOIPAY"] = "koipay";
    BindAccountType["PAY808"] = "pay808";
    BindAccountType["PAY988"] = "pay988";
    BindAccountType["KDPAY"] = "kdpay";
    BindAccountType["ALIPAY"] = "alipay";
})(BindAccountType || (BindAccountType = {}));
//# sourceMappingURL=BindAccountType.js.map